import { cs } from "@/i18n/cs";

export function BootScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Logo size={34} />
        <div className="af-label-dim">{cs.common.loading}</div>
      </div>
    </div>
  );
}

/** Diamantové logo App Factory dle /Design. */
export function Logo({ size = 24 }: { size?: number }) {
  return (
    <div
      aria-hidden
      style={{ borderRadius: "var(--radius-box)",
        width: size,
        height: size,
        border: "1px solid var(--accent)",
        transform: "rotate(45deg)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="af-animate-pulse"
        style={{
          width: Math.max(5, size * 0.29),
          height: Math.max(5, size * 0.29),
          background: "var(--accent)",
        }}
      />
    </div>
  );
}
